const url = process.env.REACT_APP_SERVER_URL;

async function api(path, options = {}) {
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  const headers = {
    ...defaultHeaders,
    ...options.headers,
  };

  const fetchOptions = {
    method: options.method || "GET",
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  };

  try {
    const response = await fetch(`${url}/${path}`, fetchOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message || "Request failed");
  }
}

export default api;
